import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Pagination from "react-js-pagination";
import { useSearchParams } from "react-router-dom";

const CustomLoading = () => <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>

const useCustomSearchParams = () => {
  const [search, setSearch] = useSearchParams();
  const searchAsObject = Object.fromEntries(
    new URLSearchParams(search)
  );
  return [searchAsObject, setSearch];
};

export default ({ columns, data, count = 0, selectableRows= false , onSelectedRowsChange = ""}) => {

  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [activePage, setActivePage] = useState()
  const [search, setSearch] = useCustomSearchParams();

  useEffect(() => {
    if (data) {
      const timeout = setTimeout(() => {
        setPending(false);
        setRows(data);
      }, 1000);
      return () => clearTimeout(timeout);
    }

  }, [data]);

  useEffect(() => {

    if (activePage != undefined) {
      setSearch({ ...search, page: activePage })

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

  }, [activePage])

  if (pending) {
    return <div className="flex bg-white shadow justify-center items-center">
      <CustomLoading />
    </div>
  }

  return <div className="bg-white w-full shadow  border border-neutral-200 p-5 text-md">
    {rows.length > 0 && <DataTable
      columns={columns}
      onSelectedRowsChange={onSelectedRowsChange}
      data={rows}
      selectableRows={selectableRows}
    />}
    {rows.length > 0 && <Pagination
      innerClass="flex flex-wrap items-center gap-x-1 mt-8"
      activeClass=" bg-gray-500 text-white"
      itemClassPrev="min-h-[38px] min-w-[38px] cursor-pointer py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-sm rounded-lg text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
      itemClassNext="min-h-[38px] min-w-[38px] cursor-pointer py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-sm rounded-lg text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
      itemClass="min-h-[38px] min-w-[38px] flex cursor-pointer  justify-center items-center text-gray-800 hover:bg-gray-100 py-2 px-3 text-sm rounded-lg focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
      activePage={activePage}
      itemsCountPerPage={50}
      totalItemsCount={count}
      pageRangeDisplayed={5}
      firstPageText="اولین"
      lastPageText="آخرین"
      nextPageText="بعدی"
      prevPageText="قبلی"
      onChange={pageNumber => setActivePage(pageNumber)}
    />}
  </div>
};
